import { formatAppointmentDate } from "@zapis24/utils";
import {
  getReturnReminderAtIso,
  parseReturnReminderDays,
  RETURN_REMINDER_DAY_OPTIONS,
  type AppointmentForReturnReminder,
} from "./appointmentsView.js";

export function ReturnReminderDaysPicker({
  appointment,
  businessTimeZone,
  daysInput,
  onDaysInputChange,
  className = "",
}: {
  appointment: AppointmentForReturnReminder;
  businessTimeZone: string;
  daysInput: string;
  onDaysInputChange: (value: string) => void;
  className?: string;
}) {
  const selectedDays = parseReturnReminderDays(daysInput);
  const reminderAt =
    selectedDays === null ? null : getReturnReminderAtIso(appointment, selectedDays, businessTimeZone);

  return (
    <div className={className}>
      <div className="flex min-w-0 items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold text-gray-700">Возврат клиента</p>
          <p className="mt-0.5 text-[11px] leading-4 text-gray-500">
            Выберите срок до нажатия финальной кнопки.
          </p>
        </div>
        <button
          type="button"
          onClick={() => onDaysInputChange("")}
          className={`shrink-0 rounded-lg border px-2 py-1 text-[11px] font-semibold transition ${
            selectedDays === null
              ? "border-gray-200 bg-gray-100 text-gray-500"
              : "border-gray-200 bg-white text-gray-500 hover:bg-gray-50"
          }`}
        >
          Не напоминать
        </button>
      </div>

      <div className="mt-2 flex flex-wrap gap-1.5">
        {RETURN_REMINDER_DAY_OPTIONS.map((option) => {
          const isSelected = selectedDays === option.days;
          return (
            <button
              key={option.days}
              type="button"
              onClick={() => onDaysInputChange(String(option.days))}
              className={`rounded-lg border px-2.5 py-1 text-xs font-semibold transition ${
                isSelected
                  ? "border-green-500 bg-green-50 text-green-700"
                  : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <label className="mt-2 flex min-w-0 items-center gap-2 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs text-gray-600">
        <span className="shrink-0">Другое:</span>
        <input
          type="number"
          min={1}
          max={365}
          value={daysInput}
          onChange={(event) => onDaysInputChange(event.target.value)}
          placeholder="дней"
          className="min-w-0 flex-1 border-0 bg-transparent text-sm font-semibold text-gray-900 outline-none"
        />
        <span className="shrink-0 text-gray-400">дн.</span>
      </label>

      <p className="mt-1.5 text-[11px] leading-4 text-gray-500">
        {reminderAt
          ? `Напомним ${formatAppointmentDate(reminderAt, businessTimeZone)} около 10:00.`
          : "Можно оставить без напоминания и настроить его позже в завершенной записи."}
      </p>
    </div>
  );
}
